<div class="background">
  <div class="container-fluid">
    <div class="d-flex flex-row">
      <div class="p-2 flex-grow-1">
        <h2 class="heading">Container Tap</h2>
      </div>
      <!-- <div class="p-2 kanbanp2">
        <input
          type="text"
          [(ngModel)]="kanbanSearchValue"
          class="form-control-sm kanbanform"
          placeholder="KANBAN - Press Enter to Search"
          (keyup.enter)="handleKanbanSearch($event)"
        />
      </div>
      <div class="p-2" *ngIf="showDownloadUploadButtons">
        <button
          *ngIf="access1.download"
          type="button"
          class="btn btn-light"
          (click)="download()"
        >
          <img
            *ngIf="access1.download"
            src="./assets/images/Group 115533.png"
            class="downloadIcon"
            alt="download icon"
          />
          TEMPLATE
        </button>
      </div>
      <div class="p-2" *ngIf="showDownloadUploadButtons">
        <input
          style="display: none"
          type="file"
          id="my-file"
          (change)="onFileChange($event, false)"
          accept=".xlsx, .xls"
        />
        <button
          *ngIf="access1.edit"
          [disabled]="batchCheck"
          type="button"
          onclick="document.getElementById('my-file').click()"
          class="btn btn-dark"
        >
          <img
            *ngIf="access1.edit"
            src="./assets/images/Mask_Group_515.svg"
            alt="Upload icon"
          />
          UPLOAD
        </button>
      </div> -->
    </div>
  </div>
  <div class="successMessage alert-dismissible">
    <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div
      *ngIf="warningMessage || freezingMesssage"
      class="alert alert-warning"
      role="alert"
    >
      <span *ngIf="warningMessage" class="freezedivider"
        >{{ warningMessage }}&nbsp; &nbsp;</span
      >&nbsp;&nbsp; <span>{{ freezingMesssage }}</span> &nbsp; &nbsp;
      <a *ngIf="uploadError" class="fileName">{{ justFileName }}</a>
      &nbsp;&nbsp;
      <button
        *ngIf="uploadError"
        type="button"
        class="btn btn-danger"
        (click)="exportAsXLSX()"
      >
        <img
          src="./assets/images/Group 115689.png"
          class="downloadIcon"
          alt="Upload icon"
        />
        ERROR REPORT
      </button>
      <button
        *ngIf="warningMessage"
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          
          
          <!-- <div class="row me-0 mt-2">
            <div *ngFor="let kanbanQty of kanbanQtyList; let i = index" class="col-xl-2 col-md-4 col-sm-6 d-flex mb-2" 
            [ngClass]="{'me-5': i !== 4}">
          
              Kanban Dropdown
              <div style="margin-right: 0.1rem">
                <span class="v1"></span>
                <label class="searchLable" style="padding-right: 4.0rem;">KANBAN</label>
                <p-multiSelect [(ngModel)]="selectedKanban[i]" [showToggleAll]="false" (onChange)="onKanbanChange(i)"
                  [options]="getFilteredKanbanList(i)" optionLabel="kanban" optionValue="kanban"
                  [disabled]="i > 0 && !selectedKanban[i - 1]" [disabled]="!isKanbanEnabled(i)" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'" autoWidth="true" [style]="{ width: '100%'}"
                  [resetFilterOnHide]="true" [filter]="true" [filterBy]="'kanban'">
                </p-multiSelect>
              </div>
          
              Qty Input Field
              <div style="margin-right: -3.1rem !important;width: 104%; margin-left: 1.5rem;" class="me-1">
                <label class="searchLable">QTY</label>
                <input class="form-control-sm qtyField" type="text" placeholder="--Type--" [(ngModel)]="kanbanQty.qty"
                  (input)="onInput($event, i)" [disabled]="!isKanbanEnabled(i)" (blur)="markAsCompleted(i)"
                  style="width: 100%;" />
              </div>
          
            </div>
          </div> -->
          <div class="row">
            <div class="col-xl-1 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DOCK</label>
                <p-dropdown [(ngModel)]="selectedDock" (onChange)="onDockChange()" [options]="dockList" optionLabel="dock"
                  [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"  [itemSize]="15"
                  autoWidth="true" placeholder="--Select--" [style]="{ width: '100%'}" [resetFilterOnHide]="true"
                  optionLabel="dock" [panelStyle]="{ width: '55%' }" [filter]="true" appendTo="body"
                  [filterBy]="'dock'">
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable" title="Container Code">CC</label>
                <p-multiSelect [(ngModel)]="selectedContainer" [showToggleAll]="false" (onChange)="onContainerChange()"
                  [options]="containerList" optionLabel="cc" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'" autoWidth="true" [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true"
                  [disabled]="disableDropdown">
                </p-multiSelect>
              </div>
            </div>
            <!-- <div class="col-xl-1 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">LIFE CYCLE CODE</label>
                <p-multiSelect [(ngModel)]="selectedLifecycle" [showToggleAll]="false" (onChange)="onLifeCycleChange()"
                  [options]="lifecycleList" optionLabel="life_cycle" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'" autoWidth="true" [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true">
                </p-multiSelect>
              </div>
            </div> -->
            <div class="col-xl-1 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">CONTAINER STATUS</label>
                <p-multiSelect [(ngModel)]="selectedStatus" [showToggleAll]="false" (onChange)="statusChange()"
                  [options]="statusList" optionLabel="container_status" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'" autoWidth="true" [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true" selected="false" [appendTo]="'body'">
                </p-multiSelect>
              </div>
            </div>
            <div class="col-xl-1 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">CONTAINER FROM</label>
                <p-dropdown [(ngModel)]="selectedContainerFrom" (onChange)="onContainerFromChange()" [options]="containerFromList"
                  optionLabel="container_renban" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" 
                  [itemSize]="15" autoWidth="true" placeholder="--Select--" [style]="{ width: '100%' }" [panelStyle]="{ width: '55%' }"
                  [filter]="true" appendTo="body"  [filterBy]="'container_renban'" [resetFilterOnHide]="true"
                  [disabled]="disableDropdown">
                </p-dropdown>
                <!-- <input [(ngModel)]="containerFrom" [max]="containerTo" class="form-control-sm qtyField" type="date" autoWidth="false" /> -->
              </div>
            </div>
            <div class="col-xl-1 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">CONTAINER TO</label>
                <p-dropdown [(ngModel)]="selectedContainerTo" (onChange)="onContainerToChange()" [options]="containerToList"
                  optionLabel="container_renban" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" 
                  [itemSize]="15" autoWidth="true" placeholder="--Select--" [style]="{ width: '100%' }" [panelStyle]="{ width: '55%' }"
                  [filter]="true" appendTo="body"  [filterBy]="'container_renban'" [resetFilterOnHide]="true"
                  [disabled]="disableDropdown">
                </p-dropdown>
                <!-- <input [(ngModel)]="containerTo" [min]="containerFrom" class="form-control-sm qtyField" type="date" autoWidth="false" /> -->
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetDropDown()">
                <img src="./assets/images/Group 115380.png" alt="refresh icon" />
              </label>
              <label class="resetlabel" (click)="onResetDropDown()">Reset</label>
              <span class="vertical"></span>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 search">
              <button class="search_btn" (click)="onSearch(0)">
                SEARCH
              </button>
            </div>
            <div class="col-xl-6 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl"></div>
            </div>
            <div class="col-xl-2 max-width-01 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                
              </div>
            </div>
            
          </div>
          <div class="row me-0 mt-2">
            <!-- Kanban Dropdown (only one required) -->
            <div class="col-xl-2 max-width-01 col-md-4 col-sm-6 d-flex mb-2"  style="position: relative; z-index: 1;">
              <div style="width: 100%;">
                <span class="v1"></span>
                <label class="searchLable" style="padding-right: 0.0rem;">KANBAN</label>
                <!-- <p-multiSelect [(ngModel)]="selectedKanban" [showToggleAll]="false" (onChange)="onKanbanChange()"
                  [options]="kanbanList" optionLabel="kanban" optionValue="kanban" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" [defaultLabel]="'--Select--'" autoWidth="true" [style]="{ width: '100%'}"
                  [resetFilterOnHide]="true" [filter]="true" [filterBy]="'kanban'" [panelVisible]="showDropdown" [disabled]="disableDropdown" 
                  >
                </p-multiSelect> -->
                <p-multiSelect id="selSupplier" [options]="kanbanList" [filter]="true" [virtualScroll]="true" [itemSize]="30"
                  [showTransitionOptions]="'0ms'" placeholder="Select" optionLabel="kanban"  optionValue="kanban"
                  [resetFilterOnHide]="true" [hideTransitionOptions]="'0ms'" autoWidth="true" [style]="{ width: '100%' }"
                  scrollHeight="180px" (onChange)="onKanbanChange()" [filterBy]="'kanban'" [(ngModel)]="selectedKanban"
                  [disabled]="disableDropdown">
                </p-multiSelect>
              </div>
            </div>
          
            <!-- Dynamically Generated Fields for Kanban, Quantity, Date, and Time -->
            <div *ngFor="let kanban of selectedKanban; let i = index" class="col-xl-2 max-width-01 col-md-4 col-sm-6 d-flex mb-2">
              <div style="margin-right: -7.3rem !important; width: 100%; margin-left: 0.1rem;" class="me-1">
                
                <!-- ✅ First Line: Kanban + Checkbox side by side -->
                <div class="d-flex align-items-center mb-1">
                  <label class="searchLable mb-0" style="width: 85%;">KB - {{kanban}}</label>
                  <input type="checkbox" style="margin-left: -0.2rem;" [checked]="true" (change)="onKanbanCheckboxChange($event, kanban)" />
                </div>
            
                <!-- ✅ Second Line: QTY Label + Input -->
                <div class="d-flex align-items-center">
                  <span class="v1" style="height: 15px;"></span>
                  <label class="searchLable" style="margin-right: 0.3rem; width: 25%;">QTY</label>
                  <input class="form-control-sm qtyField" type="text" placeholder="--Type--"
                         [(ngModel)]="kanbanQtyList[i]" style="width: 62%;" (input)="onInput($event)" maxlength="5"/>
                </div>
            
              </div>
            </div>
          </div>
          <div class="row me-0 mt-2">
            <div class="col-xl-4 max-width-01 col-md-4 col-sm-6 d-flex mb-2">
              <div class="drpchildctrl">
                <!-- <span class="v1"></span> -->
                <!-- <label class="searchLable">CHECK BOX 1</label> -->
                <!-- <label class="searchLable">SPECIFIED KANBAN'S AND QUANTITIES</label> -->
                <!-- <input  class="key" type="checkbox" placeholder="--Type--" style="margin-left: -1.1rem;"/> -->
                <!-- <label for="disabledCheckbox"></label> -->
                <!-- id="disabledCheckbox" -->
          
              </div>
            </div>
            <div class="col-xl-4 max-width-01 col-md-4 col-sm-6 d-flex mb-2">
              <div class="drpchildctrl">
                <!-- <span class="v1"></span> -->
                <!-- <label class="searchLable">CHECK BOX 2</label> -->
                <!-- <label class="searchLable">KANBAN'S NOT MATCHING WITH QUANTITIES</label> -->
                <!-- <input class="key" type="checkbox" placeholder="--Type--" style="margin-left: -1.1rem;"/> -->
                <!-- <label for="disabledCheckbox"></label> -->
                <!-- id="disabledCheckbox" -->
          
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <span class="edit_icon">
          <!-- <img
            *ngIf="access1.edit"
            [ngClass]="{ disabled: batchCheck }"
            (click)="onEditMode()"
            class="img-tool"
            src="./assets/images/edit.svg"
            alt="edit button icon"
            title="Edit"
          /> -->
          <img
            class="img-tool"
            (click)="exportAsXLSX()"
            src="./assets/images/download.svg"
            alt="download icon"
            title="Download for upload"
          />
          <!-- <img
            class="img-tool"
            (click)="exportAsXLSXSameAsUI()"
            src="./assets/images/download.svg"
            alt="download icon ui template"
            title="Download same as UI"
          /> -->
        </span>
      </div>

      <div class="col-sm-4">
        <div class="records">
          <p-multiSelect #dd
            class="page-drpdwn-label showhide"
            [(ngModel)]="selectedShowHideList"
            (onChange)="onShowHideChange($event)"
            [options]="showHideList"
            optionLabel="label"
            [displaySelectedLabel]="false"
            [defaultLabel]="'SHOW/HIDE COLUMN'"
            [showTransitionOptions]="'0ms'"
            [hideTransitionOptions]="'0ms'"
            autoWidth="true"
            [style]="{ width: '50%', background: '#F5F5F5' }"
            [resetFilterOnHide]="true"
          >
          <p-footer>
            <div class="flex justify-content-between p-1">
              <button type="button" (click)="saveShowHide();dd.hide()" class="save_btn"> Save</button>
              
            </div>
          </p-footer>
          </p-multiSelect>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="records">
          <label class="page-drpdwn-label">RECORDS / PAGE:</label>
          <select
            class="page-drpdwn"
            (change)="onPageSizeChanged()"
            [(ngModel)]="paginationPageSize"
          >
            <option value="10" selected>10</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="{{ rowData.length }}">All</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div id="dvgrid" class="gridStyle">
    <ag-grid-angular
      #tapMainGrid
      style="width: 100%; top: 1%; margin-bottom: 5%"
      class="ag-theme-balham"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [rowSelection]="rowSelection"
      [gridOptions]="gridOptions"
      [paginationPageSize]="paginationPageSize"
      [context]="context"
      [editType]="editType"
      [pagination]="true"
      [suppressClickEdit]="suppressClickEdit"
      [frameworkComponents]="frameworkComponents"
      [tooltipShowDelay]="tooltipShowDelay"
      [tooltipMouseTrack]="true"
      [groupDefaultExpanded]="groupDefaultExpanded"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [getDataPath]="getDataPath"
      [treeData]="true"
      [headerHeight]="headerHeight"
    >
    </ag-grid-angular>
  </div>
  <!-- <div *ngIf="editEnabled || uploadEnabled" class="saveCancel">
    <button
      matRipple
      [matRippleCentered]="true"
      [matRippleUnbounded]="false"
      class="review_btn"
      (click)="uploadFileBeforeSaveChanges()"
    >
      {{ editEnabled ? "Review Changes" : "Upload data" }}
    </button>
    <button (click)="cancelEdit()" class="cancel_btn">Cancel</button>
  </div> -->
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p class="loading">Loading... Please wait...</p>
</ngx-spinner>
